
const customDropDown = ()=> {
  
  const customDropdown = document.querySelector('custom-dropdown');
  if(customDropdown == null) return;
  const dropDownTrigger = customDropdown.querySelector('[js-custom-dropdown-opener]');
  const dropDownValue = customDropdown.querySelector('[js-custom-value]');
  const dropDownOptions = customDropdown.querySelectorAll('[js-custom-option]');
  const optionsWrapper = customDropdown.querySelector('[js-options-wrapper]');

  dropDownOptions.forEach((option)=> {
    option.addEventListener("click", (event) => {
      
      dropDownOptions.forEach((item)=> {
        item.classList.remove('active');
      });
      
      option.classList.add('active');
      const value = option.getAttribute('js-custom-option');
      if(dropDownValue) dropDownValue.innerHTML = value;
      customDropdown?.classList.remove('active');

      const type = option.getAttribute('value');
      const rechargeOption = document.querySelector(`.rc-widget input[value="${type}"]`);
      if(rechargeOption) {
         rechargeOption.checked = true;
        rechargeOption.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
   
  dropDownTrigger?.addEventListener("click", (event) => {
       customDropdown?.classList.toggle('active');
  });
  
  document.addEventListener("click", (event) => {
     if(event.target.closest('custom-dropdown') == null) {
          customDropdown.classList.remove('active');
     }
   });

   window.updateSubscription = (type)=> {
    const selectedOption = optionsWrapper?.querySelector(`li[value="${type}"]`);
    if(selectedOption == null) return;
    dropDownOptions.forEach((item)=> {
      item.classList.remove('active');
    });
    selectedOption.classList.add('active');
    const value = selectedOption.getAttribute('js-custom-option');
    if(dropDownValue) dropDownValue.innerHTML = value;
  }
    
}

customDropDown();



function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    (rect.top) >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}



window.addEventListener('scroll', function(event) {
 
      const scrollPosition = window.scrollY;
      let tempValue = 0
      if(window.innerWidth >= 992) {
        tempValue = 1000;
      }
      else {
         tempValue = 600;
      }
      if(scrollPosition > tempValue) {
           const mainAddToCart = document.querySelector('product-info product-form form');
           const isVislble = isElementInViewport(mainAddToCart);
           if(!isVislble) {
             document.querySelector('[js-product-sticky-bar]').classList.add('active');
           } 
           else {
               document.querySelector('[js-product-sticky-bar]').classList.remove('active');
           }
       }
});